export const pickExtensionFromFilename = (fileName?: string): string | null => {
  if (!fileName) return null;
  const lastDotIndex = fileName.lastIndexOf('.');
  const hasADot = lastDotIndex !== -1;
  if (!hasADot) {
    return null;
  }
  const size = fileName.length;
  const has4orLessCharsAfterTheDot = lastDotIndex >= size - 5;
  if (!has4orLessCharsAfterTheDot) {
    return null;
  }
  return fileName.substring(lastDotIndex + 1).toUpperCase();
};
